import React from 'react';
import { useFormContext } from 'react-hook-form';
import { FormFields } from '../../../../AccountForm.meta';
import { Toggle } from '../../../../../../../../../../CommonComponents/OPL/Toggle/Toggle';
import { useAccountFormFieldDisabled } from '../../../../hooks/useCanEditLinkedAccountOwnerAndSync';

export const SyncTransactionsToggle = () => {
  const formBag = useFormContext<FormFields>();
  const isFieldDisabled = useAccountFormFieldDisabled(true);

  const showAccount = formBag.watch('bankAccount.ShowAccount');

  return (
    <Toggle
      {...formBag.register('bankAccount.SyncTransactionsEnabled')}
      size="small"
      disabled={isFieldDisabled || !showAccount}
    >
      Sync Transactions
    </Toggle>
  );
};
